<template>
  <div v-loading="loading" element-loading-text="加载中">
    <el-row>
      <el-col :span="24">
        <div id="charts-box-copy-lbar-census"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import echarts from 'echarts'
import { API__code, API_control } from '../../../api/index.js'
export default {
  props: ['userGuishuBar'],
  data() {
    return {
      chartsXAxis: [],
      //折线图数据
      chartsData: [],
      chart: {
        x: ['2020-01', '2020-02', '2020-03', '2020-04', '2020-05', '2020-06', '2020-07'],
        y3: [150, 232, 201, 154, 190, 330, 410],
      },
      value: '1',
      loading: true,
      chartPie: [],
      token: '',
      checkCode: '',
    }
  },
  created() {},
  mounted() {},
  watch: {
    userGuishuBar: function (val) {
      this.registerCount()
    },
  },
  methods: {
    registerCount(val) {
      this.chart.x=[]
      console.log(this.userGuishuBar)
      // for(var i=0;i<this.userGuishuBar.x.length;i++){
      //   this.chart.x.push(JSON.parse(this.userGuishuBar.x[i]).value)
      // }
      this.chart.x=this.userGuishuBar.x;
      this.chart.y3 = this.userGuishuBar.y
      this.initBar()
      this.loading = false
    },
    initBar() {
      var echartsbar = echarts.init(document.getElementById('charts-box-copy-lbar-census'))
      echartsbar.clear()
      echartsbar.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: '{b0}: {c0}人',
        },
        // title: {
        //   text: "新注册用户统计",
        //   top: "top",
        //   left: "left",
        //   textStyle: {
        //     color: "#596471",
        //     fontSize: 17,
        //     fontWeight: 100,
        //   },
        // },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '0',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: this.chart.x,
            axisLine: {
              lineStyle: {
                color: '#EBEBEB',
              },
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#6E6E6E',
              },
            },
          },
        ],
        dataZoom: {
          type: 'inside',
          show: true,
          start: 0,
          end: 100,
          xAxisIndex: [0],
        },
        yAxis: [
          {
            type: 'value',
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
              alignWithLabel: false,
            },
            axisLine: {
              lineStyle: {
                color: '#EBEBEB',
              },
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#596471',
              },
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: '人数',
            type: 'bar',
            stack: '广告',
            data: this.chart.y3,
            barMaxWidth: 60,
          },
        ],
        color: ['#13c2c2'],
      })
    },
  },
}
</script>

<style scoped lang="scss">
#charts-box-copy-lbar-census {
  width: 100%;
  height: 336px;
  background-color: white;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// censusBar.vue?8a1316d6